/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDeviceTokenDto } from '../models/CreateDeviceTokenDto';
import type { DeviceTokenEntity } from '../models/DeviceTokenEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PushNotificationsService {
    /**
     * Create or update device token
     * @param requestBody
     * @returns DeviceTokenEntity
     * @throws ApiError
     */
    public static deviceTokenControllerCreateOrUpdateV1(
        requestBody: CreateDeviceTokenDto,
    ): CancelablePromise<DeviceTokenEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/device-tokens',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete device token when user logs out
     * @param deviceToken
     * @returns any
     * @throws ApiError
     */
    public static deviceTokenControllerDeleteV1(
        deviceToken: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/device-tokens',
            query: {
                'deviceToken': deviceToken,
            },
        });
    }
}
